import { IconAlertTriangle } from '@tabler/icons-react-native';
import { Column, Row } from 'app/design/primitives/box';
import { FormError } from 'app/design/primitives/form-error';
import { Switch } from 'app/design/primitives/switch';
import { Text } from 'app/design/primitives/text';
import { useFormContext } from 'app/hooks/form';
import { createTheme as createDSTheme } from 'app/shopify';
import type { CreateListingDTO } from 'app/types/listing';
import { ICON_STROKE_WIDTH } from 'app/utils/constants';
import { useTranslation } from 'react-i18next';

const theme = createDSTheme();

export function UrgentSection() {
  const { formState, setValue, watch } = useFormContext<CreateListingDTO>();
  const { t } = useTranslation('new');
  const urgent = watch('urgent');

  return (
    <Column
      backgroundColor="surface.warning.subtle"
      borderColor="text.warning"
      borderRadius="radius.lg"
      borderWidth={1}
      gap="spacing.general.x2"
      padding="spacing.general.x4"
    >
      <Row alignItems="center" gap="spacing.general.x2">
        <IconAlertTriangle strokeWidth={ICON_STROKE_WIDTH} color={theme.colors['icon.warning']} />
        <Column flex={1} gap="spacing.general.x1">
          <Text color="text.primary" fontWeight="700" variant="bodyBase">
            {t('hauteGaspesie.urgent.title')}
          </Text>
          <Text color="text.primary" variant="bodySmall">
            {t('hauteGaspesie.urgent.description')}
          </Text>
        </Column>
        <Switch
          onValueChange={(value) => setValue('urgent', value, { shouldDirty: true, shouldValidate: true })}
          value={!!urgent}
        />
      </Row>
      <FormError error={formState.errors.urgent} />
    </Column>
  );
}
